import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SupportedSearchKeywords } from './atweb-query-expression-parser.service';
import { map } from 'rxjs/operators';
import { ExpertChipExpression, SimpleChipExpression } from '@nrwl/query-emitter';
import { CommonRegEx } from '@nrwl/common-lib';
import { first, map as mapL, split, trim } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ChipConverterProvider {
  constructor(private readonly httpClient: HttpClient) {}

  async translate(expr: SimpleChipExpression[]) {
    const result = [];
    for (const ex of expr) {
      const translation = await this.translateExpression(ex);
      result.push(translation);
    }
    return result;
  }

  async translateExpression(expr: SimpleChipExpression) {
    if (expr.keyword === SupportedSearchKeywords.Location) {
      const reqBody = this.buildLocationToSiteRequest(expr);
      try {
        const siteNames = await this.httpClient
          .post('/entity/v1/sites/find', reqBody)
          .pipe(
            map((result: Array<any>) => {
              return result.length > 0 ? mapL(result, 'name') : [-1];
            })
          )
          .toPromise();
        return this.buildSitesExpression(expr, siteNames);
      } catch (error) {
        console.error(error);
      }
    } else if (expr.keyword === SupportedSearchKeywords.Host) {
      const operand = first(expr.operands);
      expr.keyword = this.getHostKey(operand);
      return expr;
    }
    return expr;
  }

  getHostKey(operand) {
    return operand.match(CommonRegEx.IP_V4_V6) ? 'ip' : 'dns';
  }

  buildSitesExpression(oldExpression: ExpertChipExpression | SimpleChipExpression, sites) {
    if ((oldExpression as ExpertChipExpression).logicalOp) {
      return new ExpertChipExpression(SupportedSearchKeywords.Site, oldExpression.operator, sites, (oldExpression as ExpertChipExpression).logicalOp);
    }
    return new SimpleChipExpression(SupportedSearchKeywords.Site, oldExpression.operator, sites);
  }

  buildLocationToSiteRequest(expr: SimpleChipExpression) {
    const reqBody = [];
    for (const operand of expr.operands) {
      this.parseLocationOperand(operand, reqBody);
    }
    return { locations: reqBody };
  }

  /**
   * Examples of strings to be parsed:
   * city, state, country
   * city, country
   * state, country
   * country
   * As you can see, we don't know if specific location string is a combination of city+country, or state+country
   * Therefore, we send it as 'both' variants (and hope at least one will match)
   */
  parseLocationOperand(operand, output) {
    const names = split(operand, ',');
    switch (names.length) {
      case 1:
        {
          output.push({
            country: this.nullSafeTrim(names[0])
          });
        }
        break;
      case 2:
        {
          output.push({
            city: this.nullSafeTrim(names[0]),
            country: this.nullSafeTrim(names[1])
          });
          output.push({
            state: this.nullSafeTrim(names[0]),
            country: this.nullSafeTrim(names[1])
          });
        }
        break;
      case 3:
        {
          output.push({
            city: this.nullSafeTrim(names[0]),
            state: this.nullSafeTrim(names[1]),
            country: this.nullSafeTrim(names[2])
          });
        }
        break;
      default: {
        console.error('unsupported number of arguments:', operand);
      }
    }
  }

  nullSafeTrim(value) {
    if (!value) {
      return undefined;
    }
    return trim(value);
  }
}
